import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { playerPageModel } from '../../model';
import { PlayerPageHeading } from '../player-page-heading';
import { PlayerPageTabs } from '../player-page-tabs';
import cls from './player-page.module.scss';

export const PlayerPage = () => {
	const [pending, currentTab] = useUnit([
		playerPageModel.$pending,
		playerPageModel.currentTabState.$value,
	]);

	return (
		<AppShell.Main
			className={cls.playerPage}
			data-tab={currentTab}
		>
			{pending && <Loader />}
			{!pending && (
				<>
					<PlayerPageHeading />
					<PlayerPageTabs />
				</>
			)}
		</AppShell.Main>
	);
};
